import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Btn from '../../../components/Btn';
import '../clients.css';
import '../../../grid.css';


const styles = {
    card: {
        minWidth: 100,
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
};


function ClientSummary({
    client, authToken, deleteClient, toggleDelete, setClient,
}) {
    return (
        <div>
            <div className="col span-3-of-11 clientCard">
                <Card >
                    <CardContent>
                        <Typography variant="h5" component="h2">
                            {client.companyName ?
                                client.companyName
                                : <div>{client.lastName}, {client.firstName}</div>
                            }
                        </Typography>
                        <div className="clientInfo">
                            <ul>
                                {client.companyName ?
                                    <li>
                                        {client.lastName}, {client.firstName}
                                    </li>
                                    : null }
                                <li>{client.email}</li>
                                <li>{client.phoneNumber}</li>
                            </ul>
                        </div>
                    </CardContent>
                    <CardActions>
                        <div>
                            {toggleDelete ?
                                <div className="row">
                                    <div className="col span-2-of-3">
                                        <Btn
                                            disabled
                                            size="small"
                                            label="Archive"
                                            className="navBtn"
                                        />
                                    </div>
                                    <div className="col span-1-of-3">
                                        <Btn
                                            disabled={!toggleDelete}
                                            size="small"
                                            label="Del"
                                            className="navBtn"
                                            onClick={() => deleteClient({ authToken, client })}
                                        />
                                    </div>
                                </div>
                                :
                                <div className="row">
                                    <div className="col span-2-of-3">
                                        <Btn
                                            to={`/customer/${client.id}`}
                                            size="small"
                                            label="View"
                                            className="navBtn"
                                            onClick={() => setClient(client)}
                                        />
                                    </div>
                                    <div className="col span-1-of-3">
                                        <Btn
                                            to={`/editclient/${client.id}`}
                                            size="small"
                                            label="Edit"
                                            className="navBtn"
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </CardActions>
                </Card>
            </div>
        </div>
    );
}

ClientSummary.propTypes = {
    client: PropTypes.object.isRequired,
    authToken: PropTypes.string.isRequired,
    deleteClient: PropTypes.func.isRequired,
    setClient: PropTypes.func.isRequired,
    toggleDelete: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ClientSummary);



// WEBPACK FOOTER //
// ./src/containers/ClientsList/ClientSummary/ClientSummary.js